import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import DataService from 'lib/DataService';

import {
	Container,
	Wrapper,
	Actions
} from './styles';

import Title from './Title';

// Action buttons
import Cancel from './actions/Cancel';
import Save from './actions/Save';

// Controllers
import Page from './Page';
import Image from './Image';
import Text from './Text';
import Map from './Map';
import Pictogram from './Pictogram';
import Contact from './Contact';
import Responsibility from './Responsibility';

// Image and pictogram select
import ListSelectableItems from './common/ListSelectableItems';
import PictogramItem from './Pictogram/PictogramItem';
import ImageItem from './Image/ImageItem';

const API = new DataService();

const controlTitles = {
	image: 'controls/type/image',
	text: 'controls/type/text',
	pictogram: 'controls/type/pictogram',
	page: 'controls/type/page',
	map: 'controls/type/map',
	contact: 'controls/type/contact',
	responsibility: 'controls/type/responsibility'
};

const controlIcons = {
	image: 'photo',
	text: 'compose',
	pictogram: 'tag',
	page: 'document',
	map: 'location',
	contact: 'user',
	responsibility: 'document'
};

const controlComponents = {
	page: Page,
	image: Image,
	text: Text,
	pictogram: Pictogram,
	map: Map,
	contact: Contact,
	responsibility: Responsibility
};


class Controls extends React.Component {
	constructor(props) {
		super(props);

		const { pageData, activeSlot } = props;
		const controlType = activeSlot === null ? 'page' : pageData.slot[activeSlot].type;
		const slotData = activeSlot !== null ? pageData.slot[activeSlot] : pageData.options;

		const selectedItems = [];

		switch(controlType) {
		case 'image':
			selectedItems.push.apply(selectedItems, slotData.data.map(image => image.file));
			break;
		case 'pictogram':
			selectedItems.push.apply(selectedItems, slotData.data.pictograms(pictogram => pictogram.field));
			break;
		default:
			break;
		}

		this.state = {
			viewItems: false,
			viewSettings: false,
			selectedItems,
		}
	}

	componentWillReceiveProps(nextProps) {
		const { pageData, activeSlot } = nextProps;
		const controlType = activeSlot === null ? 'page' : pageData.slot[activeSlot].type;
		const slotData = activeSlot !== null ? pageData.slot[activeSlot] : pageData.options;
		const selectedItems = [ ...this.state.selectedItems ];
		let viewItems = this.state.viewItems;

		if (viewItems && (!nextProps.open || activeSlot === null)) {
			viewItems = false;
		}

		switch (controlType) {
		case 'image':
			slotData.data.forEach(image => {
				if (!selectedItems.includes(image.file)) {
					selectedItems.push(image.file);
				}
			});

			this.setState(state => ({
				selectedItems: selectedItems.filter(image1 => slotData.data.findIndex(image2 => image1 === image2.file ) !== -1)
			}));
			break;
		case 'pictogram':
			slotData.data.pictograms.forEach(pictogram => {
				if (!selectedItems.includes(pictogram.field)) {
					selectedItems.push(pictogram.field);
				}
			});

			this.setState(state => ({
				selectedItems: selectedItems.filter(pictogram1 => slotData.data.pictograms.findIndex(pictogram2 => pictogram1 === pictogram2.field ) !== -1)
			}));
			break;
		default:
			break;
		}

		if (!viewItems) {
			this.setState(state => ({
				viewItems
			}));
		}
	}

	componentWillUnmount() {
		const { t, lng, activeSlot, pageData, unsavedChanges } = this.props;
		const controlType = activeSlot === null ? 'page' : pageData.slot[activeSlot].type;

		if (controlType === 'text' && lng in unsavedChanges) {
			if (window.confirm(t('controls/text/Save unsaved changes'))) {
				this.props.saveHandler();
			}
		}
	}

	selectItemHandler = id => {
	  const selectedItems = [ ...this.state.selectedItems ];

	  if (selectedItems.includes(id)) { // Remove
	    selectedItems.splice(selectedItems.indexOf(id), 1);
	  } else { // Select
	    selectedItems.push(id);
	  }

	  this.setState({ selectedItems });
	}

	viewItemsToggleHandler = viewItems => {
	  //this.props.activeIndexHandler(-1);
	  this.setState({ viewItems });
	}

	cancelHandler = () => {
	  const { viewItems } = this.state;
	  const { itemActiveIndex } = this.props;

	  this.setState(state => ({
	    viewItems: false,
	  }));

	  if (!viewItems) {
	    this.props.activeIndexHandler(-1);

	    this.props.resetChangesHandler();

	    if (itemActiveIndex === -1) {
	      this.props.toggleControlsHandler();
	    }
	  }
	}

	activeIndexHandler = index => {
	  this.setState({ viewItems: false });
	  this.props.activeIndexHandler(index);
	}

	saveImages = images => {
	  const selectedItems = images.map(image => image.file);

	  this.props.addItems(images);

	  this.setState(state => ({
	    viewItems: false,
	    selectedItems,
	  }));
	}

	savePictograms = items => {
	  const selectedItems = items.map(item => item.field);

	  this.props.addItems(items);

	  this.setState({
	    viewItems: false,
	    selectedItems,
	  });
	}

	saveHandler = () => {
	  this.setState({ viewItems: false });
	  this.props.saveHandler();
	}

	render() {
	  const {
	    t,
	    lng,
	    building,
	    pageData,
	    activeSlot,
	    open,
	    saving,
	    unsavedChanges
	  } = this.props;
	  const controlType = activeSlot === null ? 'page' : pageData.slot[activeSlot].type;
	  const controlTitle = controlType in controlTitles ? controlTitles[controlType] : 'error';
	  const controlIcon = controlType in controlIcons ? controlIcons[controlType] : 'mood-sad-outline';
	  const ControlComponent = controlType in controlComponents ? controlComponents[controlType] : null;
	  const slotData = activeSlot !== null ? pageData.slot[activeSlot] : pageData.options; // Slot or page data
	  const showCog = !['page', 'responsibility'].includes(controlType);
	  const controlProps = {
	    lng,
	    data: slotData,
	    pageData,
	    activeSlot,
	    building,
	    unsavedChanges,
	  };
	  const saveProps = {};
	  const selectableItems = [];
	  const possibleServices = building.building_services
	    .concat(building.local_services)
	    .map(service => service.replace(/-/g, '_'));
	  let showFilter = true;

	  // TODO: fix this quick fix
	  if (possibleServices.includes('electric_car_charging_station')) {
	    possibleServices.push('electric_car_charging');
	  }

	  const possiblePictograms = this.props.pictograms.filter(pictogram => {
	    const { field } = pictogram;
	    const replacedField = field.replace('building_service_', '').replace('local_service_', '');

	    if (field.indexOf('accessibility') !== -1) {
	      return true;
	    }

	    return possibleServices.includes(replacedField);
	  });

	  let hasChanges = Object.keys(unsavedChanges).length > 0 && !this.state.viewSettings;
	  let cancelText = 'controls/close';
	  let saveText = 'controls/save/Save changes';

	  const sortItems = (a,b) => {
	    if (!('sortBy' in a)) {
	      return 0;
	    } else {
	      return a.sortBy > b.sortBy ? 1 : a.sortBy < b.sortBy ? -1 : 0;
	    }
	  }

	  const buildingFieldLocalNames = this.props.config.buildingFieldLocalNames;

	  switch (controlType) {
	  case 'page':
	    controlProps.pageId = this.props.pageId;
	    controlProps.removePageDataHandler = this.props.removePageDataHandler;
	    break;
	  case 'pictogram':
	    controlProps.buildingFieldLocalNames = buildingFieldLocalNames;
	    controlProps.viewItemsToggleHandler = this.viewItemsToggleHandler;
	    controlProps.activeIndexHandler = this.props.activeIndexHandler;
	    controlProps.activeIndex = this.props.itemActiveIndex;
	    controlProps.pictograms = this.props.pictograms;
	    controlProps.viewItems = this.state.viewItems;
	    controlProps.onSortEndHandler = this.props.onSortEndHandler;
	    saveProps.viewItems = this.state.viewItems;

	    showFilter = false;

	    selectableItems.push.apply(selectableItems, possiblePictograms.map(pictogram => ({
	      id: pictogram.field,
	      selected: this.state.selectedItems.includes(pictogram.field),
	      sortBy: pictogram.field in buildingFieldLocalNames[lng]
	        ? buildingFieldLocalNames[lng][pictogram.field]
	        : 'x',
	      filter: buildingFieldLocalNames[lng][pictogram.field],
	      element: (
	        <PictogramItem
	          image={pictogram.image}
	          field={pictogram.field}
	          localName={buildingFieldLocalNames[lng][pictogram.field]}
	        />
	      ),
	    })));

	    hasChanges = hasChanges || slotData.data.pictograms.length !== this.state.selectedItems.length;

	    slotData.data.pictograms.forEach(slotPictogram => {
	      hasChanges = hasChanges || typeof this.state.selectedItems.find(field => field === slotPictogram.field) === 'undefined';
	    });

	    saveProps.addItems = () => this.savePictograms(this.state.selectedItems.map(field => {
	      if (typeof building.i18n.fi[field] === 'undefined' || typeof building.i18n.en[field] === 'undefined') {
	        return false;
	      }

	      const slotItemData = slotData.data.pictograms.find(slotItem => slotItem.field === field);
	      const mergedItemData = {
	        field,
	        i18n: {
	          fi: building.i18n.fi[field],
	          en: building.i18n.en[field],
	        },
	        ...slotItemData, // Edited values
	      }

	      return {
	        ...mergedItemData,
	        id: API.generateUuid(),
	      }
	    }).filter(item => item !== false))

	    break;
	  case 'text':
	    controlProps.editorState = activeSlot in this.props.editorState ? this.props.editorState[activeSlot] : false;
	    controlProps.updateEditorState = editorState => this.props.updateEditorState(activeSlot, editorState);
	    break;
	  case 'image':
	    controlProps.viewItemsToggleHandler = this.viewItemsToggleHandler;
	    controlProps.activeIndex = this.props.itemActiveIndex;
	    controlProps.activeIndexHandler = this.props.activeIndexHandler;
	    controlProps.viewItems = this.state.viewItems;
	    controlProps.onSortEndHandler = this.props.onSortEndHandler;
	    saveProps.viewItems = this.state.viewItems;

	    if (building.image) {
	      selectableItems.push({
	        id: building.image.file,
	        selected: this.state.selectedItems.includes(building.image.file),
	        sortBy: building.image.meta.muoto,
	        filter: building.image.name,
	        element: <ImageItem {...building.image} />,
	      });
	    }

	    selectableItems.push.apply(selectableItems, building.images.map(image => ({
	      id: image.file,
	      selected: this.state.selectedItems.includes(image.file),
	      sortBy: image.meta.muoto,
	      filter: image.name,
	      element: <ImageItem {...image} />,
	    })));

	    hasChanges = hasChanges || slotData.data.length !== this.state.selectedItems.length;

	    slotData.data.forEach(slotImage => {
	      hasChanges = hasChanges || typeof this.state.selectedItems.find(file => file === slotImage.file) === 'undefined';
	    });

	    if (this.state.viewItems) {
	      if (hasChanges) {
	        cancelText = 'controls/cancel/Cancel changes'
	      } else {
	        cancelText = 'controls/cancel/Cancel selection';
	      }
	      if (this.state.selectedItems.length > 0) {
	        saveText = 'controls/save/Use selected images';
	      }
	    }

	    saveProps.addItems = () => this.saveImages(this.state.selectedItems.map(image => {
	      const buildingImage = building.images.find(b_image => b_image.file === image);
	      const slotDataImage = slotData.data.find(slotImage => slotImage.file === image);
	      const mergedImageData = {
	        ...buildingImage, // Image file data
	        ...{ // Default values
	          position: [50, 50],
	          scale: 1,
	          size: 'cover',
	          tag: false,
						imageLanguage: false
	        },
	        ...slotDataImage, // Edited values
	      }

	      if (!buildingImage) {
	        return false;
	      }

	      return {
	        ...mergedImageData,
	        id: API.generateUuid(),
	      }
	    }).filter(image => image !== false))

	    break;
		case 'responsibility':
			controlProps.certificates = this.props.config.buildingCertificates;
			controlProps.responsibilities = this.props.config.buildingResponsibilities;
			break;
	  default:
	    break;
	  }

	  return (
	    <React.Fragment>
	      <Container open={open} saving={saving}>
	        <Title
	          icon={controlIcon}
	          title={t(controlTitle)}
	          viewSettings={this.state.viewSettings}
	          showCog={showCog}
	          settingsHandler={() => this.setState({ viewSettings: !this.state.viewSettings })}
	        />

	        <Wrapper>
	          { open &&
							<ControlComponent
							  viewSettings={this.state.viewSettings}
							  changesHandler={this.props.changesHandler}
							  saveHandler={this.props.saveHandler}
							  updateSettingsHandler={this.props.updateSettingsHandler}
							  {...controlProps}
							/>
	          }
	        </Wrapper>

	        <Actions>
	          <Cancel value={t(cancelText)} cancelHandler={this.cancelHandler} />
	          { hasChanges &&
							<Save
							  value={t(saveText)}
							  saveHandler={this.saveHandler}
							  {...saveProps}
							/>
	          }
	        </Actions>
	      </Container>
	      { this.state.viewItems &&
					<ListSelectableItems
					  showFilter={showFilter}
					  items={selectableItems.sort(sortItems).filter((item, index) => selectableItems.findIndex(item2 => item2.id === item.id) === index)}
					  selectItemHandler={this.selectItemHandler}
					/>
	      }
	    </React.Fragment>
	  )
	}
}

Controls.propTypes = {
	t: PropTypes.func,
	lng: PropTypes.oneOf(['fi', 'en']),
	building: PropTypes.object,
	pictograms: PropTypes.array,
	buildingFieldLocalNames: PropTypes.object,
	brochureId: PropTypes.string,
	pageId: PropTypes.string,
	activeSlot: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
		PropTypes.bool,
	]),
	open: PropTypes.bool.isRequired,
	saving: PropTypes.bool,
	editorState: PropTypes.object,
	pageData: PropTypes.object,
	unsavedChanges: PropTypes.object,
	itemActiveIndex: PropTypes.number,
	changesHandler: PropTypes.func,
	resetChangesHandler: PropTypes.func,
	saveHandler: PropTypes.func,
	onSortEndHandler: PropTypes.func,
	addItems: PropTypes.func,
	activeIndexHandler: PropTypes.func,
	toggleControlsHandler: PropTypes.func,
	updatePageDataHandler: PropTypes.func,
	removePageDataHandler: PropTypes.func,
	updateSettingsHandler: PropTypes.func,
	updateEditorState: PropTypes.func,
};

export default translate('translations')(Controls);
